/* eslint-disable @typescript-eslint/no-explicit-any */
import { oc } from 'ts-optchain';

import { ELM_ACTION } from 'middleware/elmActions';
import { EventAction } from 'utils/analytics/amplitudeEventConstants';
import { StoreType } from '@tock/shared/utils/connect';
import { amplitudeSendEvent } from 'utils/analytics/amplitude';
import { isEmpty } from 'es-toolkit/compat';

let justSelectedUnassignedParty = false;

export default (store: any) => (next: any) => (action: any) => {
  // If it's a select party action, mark whether we should track the next action
  if (action.type === 'SELECT_PARTY') {
    const state: StoreType = store.getState();
    if (action.payload) {
      // If the party is unassigned, indicate that
      const newlySelectedPartyTables = oc(state).service.app.app.partyIdToTableId[action.payload](
        []
      );
      if (isEmpty(newlySelectedPartyTables)) {
        justSelectedUnassignedParty = true;
      }
    }
    return next(action);
  }

  // If we did just select an unassigned party and we should count this one, sendEvent
  if (justSelectedUnassignedParty) {
    let shouldTrack = false;
    let actionName: any = null;

    if (action[ELM_ACTION]) {
      const elmAction = action[ELM_ACTION];
      shouldTrack = elmAction.trackAsPostSelectionAction;
      actionName = elmAction.elmPortName;
    } else {
      shouldTrack = (oc(action) as any).context.trackAsPostSelectionAction(false);
      actionName = action.type;
    }

    if (shouldTrack) {
      justSelectedUnassignedParty = false;
      amplitudeSendEvent(EventAction.PARTY_UNASSIGNED_SELECTED_POST_ACTION, {
        title: actionName,
      });
    }
  }

  return next(action);
};
